import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateFeedingCageConfig, updateFeedingDashboardConfig } from './api';
import type { UpdateFeedingDashboardConfig } from './configTypes';
import { FEEDING_DASHBOARD_KEY } from './useFeedingDashboard';

export function useUpdateFeedingDashboardConfig(locationId: number) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (update: UpdateFeedingDashboardConfig) =>
            updateFeedingDashboardConfig(locationId, update),
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: [FEEDING_DASHBOARD_KEY, locationId] });
        },
    });
}

/**
 * Write a single pen's overrides. Shares the overview cache key with the site-level
 * mutation, since a pen override changes the resolved config the dashboard renders.
 */
export function useUpdateFeedingCageConfig(locationId: number) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({
            cageId,
            update,
        }: {
            cageId: number;
            update: UpdateFeedingDashboardConfig;
        }) => updateFeedingCageConfig(locationId, cageId, update),
        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: [FEEDING_DASHBOARD_KEY, locationId] });
        },
    });
}
